import { Container } from "@mui/material";
import React, { useState } from "react";

import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styled from "@emotion/styled";

const WrapperAccordian = styled(Accordion)`
  border: 1px solid #000;
  background-color: transparent;
  color: #BA51FF;
  font-family: 'Poppins-Bold';
  font-weight: bolder;
  margin: 20px 0;
  box-shadow: 0px 6px 12px 0px #00000058;
`;
const Accordian = () => {
  const [expanded, setExpanded] = useState("false");

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  return (
    <div data-aos="fade-up" data-aos-duration="9000">
      <WrapperAccordian
        expanded={expanded === "panel1"}
        onChange={handleChange("panel1")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#000" }} />}
          aria-controls="panel1bh-content"
          id="panel1bh-header"
        >
          <Typography
            sx={{ textTransfom: "uppercase", width: "100%", flexShrink: 0 }}
          >Lorem ipsum dolor sit amet, consetetur sadipscing elitr?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{ width: "80%", flexShrink: 0 }}>
          Lorem ipsum dolor sit amet, consetetur sadipscing elitr?
          </Typography>
        </AccordionDetails>
      </WrapperAccordian>
      <WrapperAccordian
        expanded={expanded === "panel2"}
        onChange={handleChange("panel2")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#000" }} />}
          aria-controls="panel2bh-content"
          id="panel2bh-header"
        >
          <Typography sx={{ width: "100%", flexShrink: 0 }}>Lorem ipsum dolor sit amet, consetetur sadipscing elitr?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{ width: "80%", flexShrink: 0 }}>Lorem ipsum dolor sit amet, consetetur sadipscing elitr?
          </Typography>
        </AccordionDetails>
      </WrapperAccordian>
      <WrapperAccordian
        expanded={expanded === "panel3"}
        onChange={handleChange("panel3")}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#000" }} />}
          aria-controls="panel3bh-content"
          id="panel3bh-header"
        >
          <Typography sx={{ width: "100%", flexShrink: 0 }}>Lorem ipsum dolor sit amet, consetetur sadipscing elitr?
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography sx={{ width: "80%", flexShrink: 0 }}>Lorem ipsum dolor sit amet, consetetur sadipscing elitr?
          </Typography>
        </AccordionDetails>
      </WrapperAccordian>
    </div>
  );
};

export default Accordian;
